import { FileDto } from "../../../services/files/files.dto";
import { Button } from "primereact/button";
import pdfIcon from "../../../assets/images/pdf-icon.svg";

interface ItemTemplateForFileListProps {
  fileList: FileDto[] | undefined;
  onTemplateRemoveForFileList: (id: string) => void;
  downloadPdf: (id: string) => void;
  isItDetailPage: boolean;
}

const ItemTemplateForFileList = ({
  fileList,
  onTemplateRemoveForFileList,
  downloadPdf,
  isItDetailPage,
}: ItemTemplateForFileListProps) => {
  return (
    <div className="flex flex-column gap-3">
      {fileList!.map((item, index) => {
        return (
          <div
            key={index}
            className="flex align-items-center justify-content-between px-4"
          >
            <div className="flex align-items-center justify-content-start">
              <img
                style={{ height: "3rem", width: "3rem" }}
                role="presentation"
                src={pdfIcon}
                width={100}
                alt="presentation"
              />
              <span className="flex flex-column text-left ml-1">
                {item.name}
                <small>{item.size}</small>
              </span>
            </div>
            <div>
              <Button
                type="button"
                icon="pi pi-times"
                className="p-button-outlined p-button-rounded p-button-danger mr-1"
                onClick={(e) => {
                  e.stopPropagation();
                  onTemplateRemoveForFileList(item.id);
                }}
                visible={!isItDetailPage}
              />
              <Button
                type="button"
                outlined
                onClick={(e) => {
                  e.stopPropagation();
                  downloadPdf(item.id);
                }}
                icon="pi pi-download"
                className="p-button-outlined p-button-rounded"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ItemTemplateForFileList;
